import clsx from "clsx";
import { ExternalLinkIcon, UsersIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

import { useGetJobsWithPartialCandidacyCountsByStatus } from "@/hooks/queries";
import { Company, JobStatus } from "@/types";

export const CompanyProfileActiveJobs = ({
  className,
  company,
}: {
  className?: string;
  company: Company;
}) => {
  const { data: jobsWithPartialCandidacyCountsByStatus, status } =
    useGetJobsWithPartialCandidacyCountsByStatus({
      jobStatuses: [JobStatus.ACTIVE],
    });

  if (status === "pending") {
    // TODO: Loading state.
    return null;
  } else if (status === "error") {
    // TODO: Error state.
    return null;
  }

  return (
    <div className={clsx("flex flex-col gap-8", className)}>
      <p className="font-semibold text-slate-800">Active jobs</p>
      {jobsWithPartialCandidacyCountsByStatus.map(
        ({ job, partialCountsByCandidacyStatus }) => {
          return (
            <div
              className="flex items-center justify-between gap-4"
              key={job.id}
            >
              <div className="flex flex-col gap-1 overflow-hidden">
                <p className="truncate font-medium text-slate-700">
                  {job.title}
                </p>
                <p className="text-sm font-medium text-slate-500">
                  {job.city}, {job.state} •{" "}
                  {new Date(job.createdAt).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  })}
                </p>
              </div>
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-1">
                  <UsersIcon className="h-4 w-4 text-slate-800" />
                  <p className="text-sm font-medium text-slate-800">
                    {partialCountsByCandidacyStatus.MATCHED +
                      partialCountsByCandidacyStatus.INTERVIEW +
                      partialCountsByCandidacyStatus.OFFER}
                  </p>
                </div>
                <Button
                  onClick={() => {
                    window.open(
                      `${window.location.protocol}//${window.location.host}/companies/${company.id}/jobs/${job.id}`,
                      "_blank",
                    );
                  }}
                  size="icon"
                  variant="ghost"
                >
                  <ExternalLinkIcon className="h-4 w-4 text-primary-900" />
                </Button>
              </div>
            </div>
          );
        },
      )}
    </div>
  );
};
